module.exports = __webpack_public_path__ + "static/media/dosage.6feaab56.svg";